import { ValidationResult, Validator } from './interfaces';

export const EmailAddressFormatValidator: Validator = class {
    /**
     * Проверить email
     */
    static validate(email: string): ValidationResult {
        // 1. Должна быть не пустая строка
        if (!email || typeof email !== 'string') return { valid: false };
        // 2. Должны быть 2 части, разделенные @
        const idx = email.lastIndexOf('@');
        if (idx === -1) return { valid: false };

        const account = email.slice(0, idx);
        const address = email.slice(idx + 1);

        // 3. Длины частей
        if (account.length === 0 || account.length > 64 || address.length > 255) return { valid: false };

        // 4. Есть точка в адресе
        if (!address.includes('.')) return { valid: false };

        // 5. Длины адресной составляющей и пробелы в адресе
        const domainParts = address.split('.');
        if (domainParts.some(part => part.length > 63 || part.includes(' '))) return { valid: false };

        return { valid: true, refinedValue: email };
    }
}